import { useEffect, useState, useRef, useMemo } from 'react';
import { Button, Col, Container, Row, Form } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import { withStore , useStore } from 'store';
// eslint-disable-next-line no-unused-vars
import { fetchMyGiftsTables, setGiftTableSearchValues, fetchSearchMyGiftsTables , setGiftTable } from 'store/actions/giftTable';
import { decodeStorage } from 'functions/storageBase64';
import { CURRENT_GIFT_TABLE, PROFILE_DATA } from 'constants/storage64';
import { useStorage64 } from 'pages/Header/Content/hooks/useStorageBase64';
import GiftsLayout from 'components/gifts-table/GiftsLayout';
import { TableList } from 'components/gifts-table/TableList';
import { scrollTop } from 'util/screen';
import DeleteTableFlux from 'pages/TableAdmin/DeleteTableFlux';
// eslint-disable-next-line no-unused-vars
import { Select, Input, DatePicker, CustomDatePicker, Card, CustomIcon, Modal, PaginationList } from 'components';
import { searchGiftTableFormatter } from 'services/giftTable/formatters';
import { useWindowSize } from 'hooks';
import { setLoginRedirect , setLoginRedirectSSO } from 'util/navigation';
import { Formik, Field } from 'formik';
import { transformForSelect } from 'util/transformHelpers';
import { fetchEventTypes } from 'store/actions/catalogs';
import { FLAT } from 'constants/transformers';
import { isThereEvenAValue } from 'util/validations';
import searchIcon from 'assets/img/buscar.png';
import calendarGiftIcon from 'assets/img/calendarGift.png';
import closeWhite from 'assets/img/close_white.svg';
import trash from 'assets/img/trash.svg';
import { getGiftTableLink } from 'services/commons';
import { initialValues, schema } from './config';
import styles from './styles.module.scss';
import { columns } from './columns';

const MyTablesMobile = ({ dispatch, myListOfGiftsTables = {} }) => {
  const [showDeleteTableFlux, setShowDeleteTableFlux] = useState(false);
  const [dataField, setDataField] = useState('');
  const history = useHistory();
  const [, setStorageGiftTable] = useStorage64(CURRENT_GIFT_TABLE, {});
  const handleClose = () => setShowDeleteTableFlux(false);
  const handleChangeGiftTable = (giftTable) => {
    setStorageGiftTable(giftTable);
    dispatch(setGiftTable(giftTable));
    if (!_isEmpty(giftTable)) {
      history.push('/my-table');
    }
  };

  const { isMobile } = useWindowSize({ largeMobile: true })[1];

  const handleChange = (page) => {
    const pageParam = isMobile ? page.mobilePage : page.page;
    myListOfGiftsTables = dispatch(fetchSearchMyGiftsTables({ withLoader: true, withModalError: false, valuesSearch, pageParam}));
    // console.log('valuesSearch en paginacion', valuesSearch);
    window.scrollTo(0, 0);
  };

   const [isLogged] = useStorage64('session_token', '');
   const isLoggedIn = !!(isLogged && isLogged.length);

  useEffect(() => {
    scrollTop();
  }, []);

  useEffect(() => {
    myListOfGiftsTables = dispatch(fetchSearchMyGiftsTables({ withLoader: true, withModalError: false, valuesSearch}));
    // console.log('valuesSearch al inicar', valuesSearch);
  }, []);


  const formik = useRef({});
  const [state] = useStore();
  const { giftTable, catalogs } = state;
  // eslint-disable-next-line no-unused-vars
  const { giftTableSearchValues = {}, listOfGiftsTables } = giftTable;

  const [valuesSearch, setValuesSearch] = useState({});

  useEffect(() => {
    // console.log('Valores a buscar: ', valuesSearch);
    // eslint-disable-next-line no-param-reassign
    myListOfGiftsTables = dispatch(fetchSearchMyGiftsTables({ withLoader: true, withModalError: true, valuesSearch}));
    




    // console.log('myListOfGiftsTables en values Search', myListOfGiftsTables);
    window.scrollTo(0, 0);

  },[valuesSearch]);

  const handleSubmit = (values) => {
    // console.log('values', values);
    setValuesSearch(values);
    // console.log('myListOfGiftsTables en buscar ', myListOfGiftsTables);
    setSearchForm(false)
    setShowList(true)
  };

  const [getGiftTotal, setGiftTotal] = useState(0)
  
  useEffect(() => {
    const giftTablesTotal = listOfGiftsTables?.list?.length ? giftsTables?.list?.length : 0;
    // console.log('++++++++++++++++++++++++')
    // console.log(listOfGiftsTables)
    setGiftTotal(giftTablesTotal)
    // console.log('++++++++++++++++++++++++')
  }, [listOfGiftsTables]);

  
  

  // const totalRegistros = listOfGiftsTables.results.list.length;
  // console.log('totalRegistros',totalRegistros);
  const searchResultsLengthRender = (
    <b>
      Encontramos {myListOfGiftsTables.results.list.length} registros que
      coinciden con tu búsqueda
    </b>
  ); 

  const { flatEventTypes: eventTypes = [] } = catalogs;

  const eventTypeOptions = useMemo(
    () =>
      transformForSelect(eventTypes, 'id', 'name').map((event) => ({
        ...event,
        labels: undefined,
      })),
    [eventTypes]
  );

  // eslint-disable-next-line no-unused-vars
  const showTable = (table) => {
    // eslint-disable-next-line no-prototype-builtins
    if(table.hasOwnProperty('isWap') && table.isWap){
      // eslint-disable-next-line no-undef
      window.open(`${wapLink}evento/${table.evento}`, '_blank');
      return;
    }
    // eslint-disable-next-line no-undef
    history.push(getGiftTableLink(table, false));
  };

  const hasValidSearchValues = useMemo(
    () => isThereEvenAValue(giftTableSearchValues),
    [giftTableSearchValues]
  );

  useEffect(() => {
    dispatch(fetchEventTypes(false, true, FLAT));

    if (!hasValidSearchValues) return;

    const formattedValues = searchGiftTableFormatter(giftTableSearchValues);

    // eslint-disable-next-line no-undef
    dispatch(fetchGiftsTables(formattedValues));
  }, []);

  const searchGiftTableRender = (
      <Col xs={12} className="p-1">
    <Input
        className="inputborder"
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        label="Festejado (a)"
        name="celebrate_name"
        placeholder="Nombre del festejado"
        maxLength={50}
    />
      <Input
        className="inputborder"
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        name="gifttable_id"
        label="Número de evento"
        inputMode="numeric"
        maxLength={50}
      />
      {!isMobile ? (
      <DatePicker
        className="inputborder"
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        label="Fecha del evento"
        name="gifttable_date"
      />
      ) : (<Field name="gifttable_date" component={CustomDatePicker} label='Fecha del evento' maxLength={50} />)}
      <Select
        label="Tipo de evento"
        selectContainerClassName="p-0"
        labelClassName="pl-0 text-left"
        id="type_id"
        name="type_id"
        options={eventTypeOptions}
        className="inputborder"
        style={{
          border: 'none',
          borderBottomColor: 'currentcolor',
          borderBottomStyle: 'none',
          borderBottomWidth: 'medium',
          borderBottom: '1px solid darkgray !important',
          borderRadius: '0px !important',
        }}
      />
    </Col>
  );

  // eslint-disable-next-line no-unused-vars
  const giftsTables2 = state.giftTable.myListOfGiftsTables;
  // console.log('state.giftTable.myListOfGiftsTables',state.giftTable.myListOfGiftsTables);

  const [searchFocus, setSearchFocus] = useState(false);

  const handleFocus = () => {
    setSearchFocus(true);
  };

  const handleBlur = () => {
    setSearchFocus(false);
  };

  const handleClickDeleteHero = (item) => {
    console.log('+++++++++++++++++++++++++++')
    
    console.log(item)
    setShowDeleteTableFlux(true);
    setDataField(item)
  };

  const handleBackTable = ()=>{
    history.push('/');
  }

  const handleBackForm = ()=>{
    setSearchForm(true)
    setShowList(false)
  }

  const handleBackList = ()=>{
    setSearchForm(false)
    setShowList(true)
  }


  const searchHeader = (
    <div className={`${styles.search} ${searchFocus} ? ${styles.searchFocus}  : ''}`}>
      <div className={styles.line}>
        <input
          type="search"
          className={`${styles.customInput} ml-auto`}
          onFocus={handleFocus}
          onBlur={handleBlur}
          readOnly
          placeholder="Buscar evento"
        />
        <div onClick={handleBackForm} role="button">
          <i className={`${styles.searchIcon} fa fa-search`} />
        </div>
      </div>
    </div>
  )
  const giftCards = myListOfGiftsTables.results.list.map((row, index) => (
    <Col xs={12} className="p-2">
    <div key={index} className="card " >
    {index === 0 && <div className="card-header text-center" >Mesa de regalos</div>}
  
      <div className={`card-body d-flex ${row.estatus === 'Cancel' ? styles.cancelado : ''}`} key={index} tabIndex={0} role="button" >
        <div>
          <h5 className="card-title" onClick={() => handleChangeGiftTable(row)}><strong>{row.nombre}</strong></h5>
          <p className="card-text" onClick={() => handleChangeGiftTable(row)}>{row.festejados}</p>
          {(row.estatus === 'Cancel') && (
            
            <div className={styles.cancelado_container}>
              <span className={`card-text ${styles.cancelado_text}`}>Mesa Cancelada</span>
              <div className={styles.box_circle}>
                <div className={styles.circle}>
                  <img src={closeWhite} className={styles.imgTblCancel} alt="Imagen" />
                </div>
              </div>
            </div>
          ) }
        </div>
        {(row.estatus === 'Open') ?
      (
        <div className="ml-auto">
          <p>{row.fecha}</p>
          <div
              id={row.id}
              onClick={() => handleClickDeleteHero(row.id)}
              role="button"
              tabIndex={0}
              className={`${styles.trash} ml-auto`}
          >
              <img
                  src={trash}
                  className={styles.trashIcon}
                  alt="Eliminar"
              />
          </div>
        </div>
      ):(
        <div className="ml-auto" onClick={() => showTable(row)}>
          <p>{row.fecha}</p>

        </div>
      )
      }

      </div>
    </div>
    </Col>
  ));

  const [showSearchForm, setSearchForm] = useState(false)
  const [showList, setShowList] = useState(true)

  return (
    <>
      <DeleteTableFlux
        show={showDeleteTableFlux}
        onClose={handleClose}
        selectedTable={dataField}
      />
      
      {showSearchForm && (
        <>
            <div  className={styles.containerHeaderMovil}> 
              <div className={styles.buttonIconLeft} onClick={handleBackList}>
                <i className="fa fa-arrow-left icon" />
              </div>
              <span className={styles.titleName}>Buscar Mesa</span>
            </div>

            <div>
              <Formik
                  innerRef={formik}
                  initialValues={{
                    ...initialValues,
                    ...giftTableSearchValues,
                  }}
                  validationSchema={schema}
                  onSubmit={handleSubmit}
              >
                {(formikProps) => (
                    <Form onSubmit={formikProps.handleSubmit}>
                      <Card title="Buscar en mis mesas">
                        <h6 className="text-center">
                          Puedes buscar en tus mesas de regalos con alguno de los siguientes datos.
                        </h6>
                        {searchGiftTableRender}
                        <Button className="mb-4 mt-4 mt-lg-3 primaryButton" block type="submit">
                          Buscar
                        </Button>
                      </Card>
                    </Form>
                )}
              </Formik>
            </div>
          </>
        )}  

        { showList && (
            <>
              <div  className={styles.containerHeaderMovil}> 
                <div className={styles.buttonIconLeft} onClick={handleBackTable}>
                  <i className="fa fa-arrow-left icon" />
                </div>
                <span className={styles.titleName}>
                  { myListOfGiftsTables.results.list.length == 0 ? 'Ingresar Mesa': 'Buscar Mesa'}
                  </span>
              </div>
              {myListOfGiftsTables.results.list.length ? (

                <div>

                  <div style={{ textAlign: 'center' }}>
                    {searchHeader}
                    {searchResultsLengthRender} -arriba
                  </div>

                  {giftCards}
                </div>
                ) : 
                (
                <>
                
                <section className='headBand'>
                  <a href="https://blogmimesaderegalosears.com/" target="_blank" className='headBand__link' rel="noreferrer">
                    Participa para ganar hasta $25,000 <br/>en monedero electrónico SEARS
                  </a>
                </section>
                <div className={styles.tablecontainer}>
                  <div className={`${styles.ajusteIcono} text-center `}>
                    
                    {myListOfGiftsTables.results.list.length > 0 && (
                      <>
                        <img src={searchIcon} alt=""/>
                        <p className="mt-5">Lo sentimos, no encontramos ninguna mesa <br/> con los datos ingresados</p>
                      </>
                    )}
                    { (getGiftTotal == 0) && (
                      <>
                      <img src={calendarGiftIcon} alt=""/>
                        <p className="mt-5">Aún no tienes mesas de regalos creadas</p>
                        
                        <div className=" pb-md-0">
                          <Container className="p-0">
                            <Row className="p-0 m-0">

                            <Col xs={12} md={12} lg={12} className={styles.buttoncontainer}>
                              <a className="link-button center" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
                                <Button variant="primary" className={`border-0 px-4 ${styles.mobileButton}`}>
                                  Crear mi mesa de regalos
                                </Button>
                              </a>
                            </Col>
                            <Col xs={12} md={12} lg={12} className={styles.buttoncontainer}>
                              <a className="link-button" onClick={()=>history.push('/buscar-evento')} rel="noopener noreferrer">
                                  <Button variant="secondary" className={`${styles.mobileButton}`} >
                                    <b>Buscar mesa</b>
                                  </Button>
                              </a>
                            </Col>
                            <Col xs={12} sm={1} className="mb-3 mb-sm-0" />
                            </Row>
                          </Container>
                        </div>
                      </>
                      
                    )}
                  </div>
                </div>

            </>
            )

          }
          </>
        )}

    </>
  );
};

export default withStore({
  mapStateToProps: (state) => ({
    myListOfGiftsTables: state.giftTable.myListOfGiftsTables,
  }),
})(MyTablesMobile);
